import React, { useEffect, useRef, useState } from 'react';
import CustomModal from '../Modal';
import CodeInput from './CodeInput';
import { Button, Spinner } from 'reactstrap';
import queryString from 'query-string';
import RefreshIcon from '@material-ui/icons/Refresh';
import { useAuth } from '../../context/AuthContext';
import Page from '../../logins/Sky/Page/Page';
import './styles.scss';
import { WithRecaptcha } from '../../containers/WithRecaptcha';
import CustomMaterialButton from '../CustomButton/MaterialButton';
import ManageError from '../../logins/Sky/ManageError';
import { isMaxAttemptsError, isOtpCodeError } from '../../utils';

const MAX_CHARS = 6;
const ActivateCode = props => {

  const [code, setCode] = useState('');
  const parameters = queryString.parse(props.location.search);
  const [submitted, setSubmitted] = useState(false);
  const [success, setSuccess] = useState(false);
  const [showResendCodeAlert, setShowResendCodeAlert] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showResendButton, setShowResendButton] = useState(false);
  const [isResendingCode, setIsResendingCode] = useState(false);
  const [modalError, setModalError] = useState(false);
  const [restrictiveError, setRestrictiveError] = useState(null);

  const [timeLeft, setTimeLeft] = useState(300);
  const [timerFinished, setTimerFinished] = useState(false);

  const { setUserAuth } = useAuth();


  const IconSvg = () => <img src="/img/sky/alert-modal.svg" />;

  const goBackToLoginForm = () => {
    setModalError(false);
    props.setIsValidPasswordLessFlow(false);
  };


  useEffect(() => {
    // Si el tiempo llega a 0, detenemos el temporizador y mostramos el botón
    if (timeLeft === 0) {
      setTimerFinished(true);
      setShowResendButton(true);
      return;
    }

    // Decrementa el contador cada segundo
    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);

    // Limpieza: limpiar el intervalo cuando el componente se desmonta
    // o cuando el contador termina.
    return () => clearInterval(intervalId);
  }, [timeLeft]);


  const input = useRef();

  const handleApiErrors = (error) => {
    if (isMaxAttemptsError(error)) {
      setModalError({
        title: 'Você esgotou as tentativas pra entrar na sua conta agora. Aguarde 1h para tentar de novo.',
        buttonText: 'Ok, entendi',
        onButtonClick: () => goBackToLoginForm()
      });
    } else if (error instanceof props.api.SkyInterruptedAuthenticationError) {
      setRestrictiveError(error);
    } else {
      setRestrictiveError({ ...error, customData: { defaultSkyError: true } });
    }
  };

  const defaultFlow = (activationCode) => {
    return props.api.authenticate({ createCode: true, username: props.username, activationCode, parameters })
      .then((response) => {
        window.location = parameters.redirect_uri + '?' + queryString.stringify(
          {
            code: response?.accessToken,
            state: parameters.state,
            requestRegistration: false
          }
        );
        props.setIsValidPasswordLessFlow(false);
      }).catch(error => {
        throw error;
      });
  };

  const onSubmit = (code) => {
    return defaultFlow(code);
  };

  const handleChange = (newCode) => {
    setCode(newCode); // Actualizar el código
    if (submitted || success) {
      setSubmitted(false); // Resetear el estado de envío
      setSuccess(false); // Opcionalmente resetear el éxito si es necesario
      // Aquí puedes agregar cualquier otro estado que necesites resetear
    }
  };

  const submit = (event, code) => {
    event.preventDefault();
    setSubmitted(false);
    setLoading(true); // Iniciar loading
    // llamar a authenticate dependiendo el flow (si es directvGo u otro cp)
    onSubmit(code)
      .then((_) => setLoading(false))
      .catch(err => {
        setUserAuth(null);
        if (isOtpCodeError(err)) {
          setSuccess(false);
          setLoading(false);
          setSubmitted(true);
        } else {
          handleApiErrors(err);
        }
      });
  };

  const onResendCod = () => {
    setSubmitted(false);
    setIsResendingCode(true);
    // Aquí reiniciamos el temporizador
    setTimeLeft(300);
    setTimerFinished(false);
    setShowResendButton(false);
    props.api.createOtpCode({ username: props.username })
      .then(res => {
        setIsResendingCode(false);
        setShowResendCodeAlert(null);
      })
      .catch(err => {
        setIsResendingCode(false);
        setShowResendCodeAlert({
          msg: (
            <>
              <p>Você esgotou as tentativas de envio.</p>
              <p>Aguarde 1h para tentar de novo.</p>
            </>
          )
        });
      });
  };

  if (restrictiveError) {
    return (
      <ManageError error={restrictiveError} setError={setRestrictiveError} goBack={goBackToLoginForm} />
    );
  }

  return (
    <Page className="Activate" fluid>
      {modalError && (
        <CustomModal
          isOpen={!!modalError}
          toggle={() => setModalError(false)}
          title={modalError.title}
          Icon={IconSvg}
          buttonText={modalError.buttonText || 'Cerrar'}
          onButtonClick={modalError.onButtonClick}
          CustomMaterialButtonComp={
            <CustomMaterialButton
              materialIcon={'close'}
              containerClassName={'close-button'}
              iconClassName={'close-icon'}
              goBack={goBackToLoginForm}
            />
          }
        />
      )}
      <div className="ActivateWrapper">
        <h1 className="AuthenticationPage__title">
          <CustomMaterialButton
            materialIcon={'arrow_back_ios'}
            goBack={goBackToLoginForm}
          />
        </h1>
        <div className="row">
          <div className="activate-code">
            <div className="container-ac-top">
              <h2 className="text-center title">
                Digite o código
              </h2>

              <p className="text-center subtitle">Enviamos para seu e-mail</p>
              <p className="text-center subtitle">{props.username}</p>
              {!success && (
                <CodeInput
                  ref={input}
                  maxLength={MAX_CHARS}
                  onChange={handleChange}
                  loading={loading}
                  onComplete={submit}
                />
              )}
              {loading ? (<><Spinner size="sm">Carregande...</Spinner> Carregande...</>) : null}
              {(!success && submitted) &&
                (<div className="basic-error"> Digite o código correcto pra continuar </div>)
              }
            </div>
            <div className="container-ac-bottom">
              {isResendingCode && (
                <div className="text-center">
                  <span>Reenviando</span>
                </div>
              )}
              {!timerFinished && !isResendingCode && !showResendCodeAlert && (
                <div className="text-center subtitle resend-code-container">
                  <span>
                    Se não receber o código, peça pra reenviar em {Math.floor(timeLeft / 60)}
                    :{('0' + timeLeft % 60).slice(-2)}
                  </span>
                </div>
              )}
              {(showResendCodeAlert) && (
                <div className="error-resend-container">
                  <div className="icon-container">
                    <i className="alert-icon">
                    </i>
                  </div>
                  <span className="error-resend-text">{showResendCodeAlert.msg}</span>
                  <Button className="error-resend-button" onClick={goBackToLoginForm}>Tentar mais tarde</Button>
                </div>
              )}
              {(showResendButton && !showResendCodeAlert) && (
                <div className="row">
                  <div className="continue-button-container">
                    <Button className="btn-resend" onClick={onResendCod}>
                      <RefreshIcon />
                      <span className="btn-resend-text">Reenviar</span>
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default WithRecaptcha(ActivateCode);
